import { Image, Skeleton } from '@vizit/atoms';
import { cva, cx } from '@vizit/theme';
import { type BenchmarkMosaicProps, BenchmarkMosaicSize } from './types';

const MOSAIC_CELLS = 4;

const gridClasses = cva({
  base: 'grid grid-cols-2 bg-white',
  variants: {
    size: {
      card: 'gap-1',
      thumbnail: 'h-20 w-20 shrink-0 gap-px overflow-hidden rounded-xs',
    },
  },
});

const cellClasses = cva({
  base: 'relative overflow-hidden bg-secondary',
  variants: {
    size: {
      card: 'aspect-[5/2] w-full',
      thumbnail: 'h-full w-full',
    },
  },
});

/**
 * A 2×2 mosaic of a custom benchmark's images. Decorative: the benchmark name
 * is read from the surrounding text, so the mosaic is hidden from assistive tech.
 */
function BenchmarkMosaic(props: BenchmarkMosaicProps) {
  const { name, urls = [], isLoading = false, size = BenchmarkMosaicSize.Card, className } = props;

  return (
    <div className={cx(gridClasses({ size }), className)} aria-hidden>
      {Array.from({ length: MOSAIC_CELLS }, (_, index) => {
        const url = urls[index];
        const key = `${name}-mosaic-${index}`;

        if (isLoading) {
          return <Skeleton key={key} variant="square" className={cellClasses({ size })} />;
        }

        return (
          <div key={key} className={cellClasses({ size })}>
            {url ? <Image src={url} name="" shape="unset" contain={false} className="h-full w-full" /> : null}
          </div>
        );
      })}
    </div>
  );
}

export { BenchmarkMosaic };
